import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Mail, Phone } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import SEO from "@/components/SEO";
import { api } from "@/lib/api";

export default function AdminInbox() {
  const [contacts, setContacts] = useState([]);
  const [users, setUsers] = useState([]);
  const [notifs, setNotifs] = useState([]);

  const load = () => {
    api.get("/admin/contacts").then((r) => setContacts(r.data)).catch(() => {});
    api.get("/admin/users").then((r) => setUsers(r.data)).catch(() => {});
    api.get("/admin/notifications").then((r) => setNotifs(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, []);

  const delContact = async (id) => { await api.delete(`/admin/contacts/${id}`); toast.success("Deleted"); load(); };

  return (
    <div>
      <SEO title="Inbox & Users | Admin" />
      <h1 className="font-display text-2xl font-bold tracking-tight">Inbox & Users</h1>
      <Tabs defaultValue="messages" className="mt-6">
        <TabsList><TabsTrigger value="messages">Messages ({contacts.length})</TabsTrigger><TabsTrigger value="users">Users ({users.length})</TabsTrigger><TabsTrigger value="notifs">Notifications</TabsTrigger></TabsList>

        <TabsContent value="messages" className="mt-4 space-y-3">
          {contacts.length === 0 && <p className="text-slate-500 text-sm">No messages.</p>}
          {contacts.map((c) => (
            <div key={c.id} className="rounded-xl border border-white/10 bg-white/5 p-5">
              <div className="flex justify-between items-start gap-4">
                <div>
                  <p className="font-semibold">{c.name} {c.subject && <span className="text-slate-500 font-normal">· {c.subject}</span>}</p>
                  <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-slate-400 mt-1">
                    <span className="inline-flex items-center gap-1"><Mail className="w-3 h-3" /> {c.email}</span>
                    {c.phone && <span className="inline-flex items-center gap-1"><Phone className="w-3 h-3" /> {c.phone}</span>}
                    <span>{new Date(c.created_at).toLocaleString()}</span>
                  </div>
                  <p className="mt-3 text-sm text-slate-300">{c.message}</p>
                </div>
                <Button size="icon" variant="ghost" onClick={() => delContact(c.id)} className="text-red-400 hover:text-red-300"><Trash2 className="w-4 h-4" /></Button>
              </div>
            </div>
          ))}
        </TabsContent>

        <TabsContent value="users" className="mt-4">
          <div className="rounded-xl border border-white/10 overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-white/5 text-slate-400"><tr><th className="text-left p-3">Name</th><th className="text-left p-3">Email</th><th className="text-left p-3">Role</th><th className="text-left p-3">Joined</th></tr></thead>
              <tbody>
                {users.map((u) => (
                  <tr key={u.id} className="border-t border-white/5"><td className="p-3">{u.name}</td><td className="p-3 text-slate-400">{u.email}</td><td className="p-3"><Badge className={u.role === "admin" ? "bg-primary text-white" : "bg-white/10 text-slate-300"}>{u.role}</Badge></td><td className="p-3 text-slate-500">{u.created_at ? new Date(u.created_at).toLocaleDateString() : "—"}</td></tr>
                ))}
              </tbody>
            </table>
          </div>
        </TabsContent>

        <TabsContent value="notifs" className="mt-4 space-y-2">
          {notifs.length === 0 && <p className="text-slate-500 text-sm">No notifications.</p>}
          {notifs.map((n) => (
            <div key={n.id} className="rounded-lg border border-white/10 bg-white/5 p-4 flex justify-between"><div><p className="font-medium text-sm">{n.title}</p><p className="text-xs text-slate-400">{n.message}</p></div><span className="text-xs text-slate-500">{new Date(n.created_at).toLocaleString()}</span></div>
          ))}
        </TabsContent>
      </Tabs>
    </div>
  );
}
